module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "ote_logo_footer.168a8702.svg";